"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const LogoIcon_vue_1 = __importDefault(require("@/components/data/LogoIcon.vue"));
const menu_1 = __importDefault(require("../../data/menu"));
exports.default = (0, vue_1.defineComponent)({
    name: 'LogoView',
    components: {
        LogoIcon: LogoIcon_vue_1.default
    },
    data() {
        return {
            menu: menu_1.default
        };
    }
});
